<template>
  <div class="menu-wrapper">
    <template v-for="item in routes">
      <template v-if="!item.hidden && item.children">
        <router-link
          v-if="
            hasOneShowingChildren(item.children) &&
            !item.children[0].children &&
            !item.alwaysShow
          "
          :to="parsePath(item.path + '/' + item.children[0].path)"
          :key="item.children[0].name"
        >
          <el-menu-item
            :index="parsePath(item.path + '/' + item.children[0].path)"
            :class="{ 'submenu-title-noDropdown': !isNest }"
          >
            <svg-icon
              v-if="item.children[0].meta && item.children[0].meta.icon"
              :icon-class="item.children[0].meta.icon"
            ></svg-icon>
            <span v-if="item.meta.title" slot="title">{{
              item.meta.title
            }}</span>
          </el-menu-item>
        </router-link>

        <el-submenu
          v-else
          :index="item.name || item.path"
          :key="item.name"
          popper-class="sidebar-shell-popup"
        >
          <template slot="title">
            <svg-icon
              v-if="item.meta && item.meta.icon"
              :icon-class="item.meta.icon"
            ></svg-icon>
            <span v-if="item.meta && item.meta.title" slot="title">{{
              item.meta.title
            }}</span>
          </template>

          <template v-for="child in item.children">
            <template v-if="!child.hidden">
              <sidebar-item
                :is-nest="true"
                class="nest-menu"
                v-if="child.children && haveShowChildren(child.children)"
                :routes="[child]"
                :key="parsePath(child.path)"
              ></sidebar-item>
              <router-link
                v-else
                :to="parsePath(item.path + '/' + child.path)"
                :key="child.name"
              >
                <el-menu-item :index="parsePath(item.path + '/' + child.path)">
                  <svg-icon
                    v-if="child.meta && child.meta.icon"
                    :icon-class="child.meta.icon"
                  ></svg-icon>
                  <span v-if="child.meta && child.meta.title" slot="title">{{
                    child.meta.title
                  }}</span>
                </el-menu-item>
              </router-link>
            </template>
          </template>
        </el-submenu>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BuyersSidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    enterpriseID: String
  },

  methods: {
    haveShowChildren(children) {
      const showingChildren = children.filter((item) => {
        return !item.hidden;
      });
      if (showingChildren.length > 0) {
        return true;
      }
      return false;
    },
    hasOneShowingChildren(children) {
      const showingChildren = children.filter((item) => {
        return !item.hidden;
      });
      if (showingChildren.length === 1) {
        return true;
      }
      return false;
    },
    parsePath(path) {
      if (path.indexOf(':orderState') != -1) {
        path = path.replace(':orderState', 'all');
      }
      return path;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue